export default __webpack_public_path__ + "static/media/plane-icon.65b2fa79.svg";